export enum EmployerCodes {
    AVAILABLE = 7,
}
